import graphql from "babel-plugin-relay/macro";

import { useMutationWithError } from "../../../../../../../../utils/hooks/useMutationWithError";
import {
  UpdateMemberProfileHiddenInput,
  useUpdateMemberProfileHiddenMutation,
} from "./__generated__/useUpdateMemberProfileHiddenMutation.graphql";

export const useUpdateMemberProfileHidden = () => {
  const [commitUpdateMemberProfileHidden, isUpdatingMemberProfile] =
    useMutationWithError<useUpdateMemberProfileHiddenMutation>(
      useUpdateMemberProfileHiddenMutationString
    );

  const updateMemberProfileHidden = (
    payload: UpdateMemberProfileHiddenInput
  ) => {
    commitUpdateMemberProfileHidden({
      variables: { input: payload },
      onCompleted: () => {},
    });
  };

  return [updateMemberProfileHidden, isUpdatingMemberProfile] as const;
};

export const useUpdateMemberProfileHiddenMutationString = graphql`
  mutation useUpdateMemberProfileHiddenMutation(
    $input: UpdateMemberProfileHiddenInput!
  ) {
    responsePayload: updateMemberProfileHidden(input: $input) {
      user {
        id
        memberProfiles(active: true) {
          edges {
            node {
              hidden
              id
              onboardedAt
            }
          }
        }
      }
      success
      errors {
        code

        message
        field
      }
    }
  }
`;
